import BaseModel from "./BaseModel";
import { action, makeObservable, observable } from "mobx";
import { post } from "../common/requester";

/**
 * Loads members of a COMPANY TEAM (company_teams.id) for TRAINING/CLUB purposes.
 * Returns options as [{id: company_user_id, name: title}]
 */
export default class TeamMembers extends BaseModel {
  constructor(store) {
    super(store);
    makeObservable(this, {
      team_id: observable,
      members: observable,
      setTeam: action,
      clear: action,
      load: action
    });
  }

  team_id = null;
  members = []; // [{id, name}] where id = company_user_id

  setTeam(team_id) {
    this.team_id = team_id ?? null;
  }

  clear() {
    this.members = [];
  }

  async load({ company_id, team_id } = {}) {
    const tid = team_id ?? this.team_id;
    if (!company_id || !tid) {
      this.clear();
      return;
    }

    const ret = await post("team/members/dropdown", {
      company_id,
      team_id: tid
    })
      .catch((e) => console.error("--team/get_team_members error", e))

    if (ret && ret.result === 0) {
      this.members = (ret.members || []).map((m) => ({
        id: m.id, // company_user_id
        name: m.title || m.name || `#${m.id}`
      }));
    } else {
      this.clear();
    }

    return ret;
  }
}